// AI service for generating enhanced tarot reading explanations using OpenRouter AI
import api from './api';
import logger from '../utils/logger';

const aiService = {
  /**
   * Generate AI-enhanced explanation for tarot spread reading using OpenRouter
   * @param {Object} spreadData - The spread reading data
   * @param {string} language - The language code for the response
   * @returns {Promise<Object>} AI-generated explanation
   */
  async generateSpreadExplanation(spreadData, language = 'en') {
    try {
      const dataWithLanguage = {
        ...spreadData,
        language: language
      };
      const response = await api.generateAIExplanation(dataWithLanguage);
      return response;
    } catch (error) {
      logger.error('Error generating AI explanation via OpenRouter:', error);
      throw error;
    }
  },

  /**
   * Format spread data for AI processing
   * @param {Object} options - Spread configuration options
   * @returns {Object} Formatted data for AI
   */
  formatSpreadForAI(options) {
    const {
      spreadName,
      spreadType,
      cards,
      question,
      notes,
      cardCount,
      spreadInterpretations
    } = options;

    return {
      spreadName,
      spreadType,
      question: question || "",
      notes: notes || "",
      cardCount,
      cards: cards.map((card, index) => ({
        position: spreadInterpretations[index] || `Card ${index + 1}`,
        cardName: card.name,
        cardPosition: card.position || 'upright',
        basicMeaning: card.meaning,
        image: card.image,
        link: card.link
      }))
    };
  }
};

export default aiService;
